import { css, fillOutlined, circle, shade } from './draw-utils';
import type { ProceduralDef } from '../types';

const HULL = 0x8a93a8; // steel capital-ship hull
const TRIM = 0xf5a623; // command gold

/**
 * B14 Admiral — a capital flagship. Wide armored hull with side
 * batteries and a glowing command bridge (the weak point, exposed when the
 * escort fleet is down). Frame 0 shielded / frame 1 exposed. docs/02 pool.
 */
export const bossAdmiralBody: ProceduralDef = {
  key: 'boss/admiral/body',
  width: 200,
  height: 130,
  anchorX: 0.5,
  anchorY: 0.5,
  frames: 2,
  draw(ctx, w, h, frame) {
    const c = w / 2;
    const cy = h / 2;
    const exposed = frame === 1;

    // Arrowhead capital hull (points down toward the arena)
    ctx.beginPath();
    ctx.moveTo(c, cy + 56);
    ctx.lineTo(c + 84, cy - 12);
    ctx.lineTo(c + 50, cy - 44);
    ctx.lineTo(c - 50, cy - 44);
    ctx.lineTo(c - 84, cy - 12);
    ctx.closePath();
    fillOutlined(ctx, HULL, 6);

    // Side batteries (turret nubs)
    ctx.fillStyle = css(shade(HULL, 0.7));
    for (const ox of [-58, -30, 30, 58]) {
      circle(ctx, c + ox, cy - 18, 9);
      ctx.fill();
    }

    // Hull plating lines
    ctx.strokeStyle = css(shade(HULL, 0.6));
    ctx.lineWidth = 3;
    ctx.beginPath();
    ctx.moveTo(c - 50, cy - 20);
    ctx.lineTo(c + 50, cy - 20);
    ctx.moveTo(c, cy - 44);
    ctx.lineTo(c, cy + 40);
    ctx.stroke();

    // Command bridge — the weak point. Dim gold when shielded, hot when exposed
    circle(ctx, c, cy - 6, 16);
    fillOutlined(ctx, exposed ? TRIM : shade(TRIM, 0.5), 4);
    circle(ctx, c, cy - 6, exposed ? 8 : 6);
    ctx.fillStyle = exposed ? '#fff2cc' : css(shade(TRIM, 0.7));
    ctx.fill();
  },
};
